import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'
import apiHeaders from 'api/Utility/ApiHeaders'
import visitorEngagementFormattedResponses from 'api/ResponseFormats/Reporting/Overview/VisitorEngagement'
import { handleStatus500 } from 'api/Utility/HandleStatus500'
import apiWrapper from 'api/Utility/ApiWrapper'
import { defineCancelApiObject } from 'api/Utility/AxiosAbortController'

const axiosCommonReq = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    paramsSerializerConfig: true,
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const noHeaderData = apiHeaders.noHeaderData()

const visitorEngagementEndpoints = {
  getVisitorCardData: async (
    params = { filterParams: {}, accessToken: '', password: '' },
  ) => {
    const signal = await cancelApiObject[
      'getVisitorCardData'
    ].handleRequestCancellation().signal

    const dashboardUrl = params.accessToken
      ? 'stakeholder_dashboards'
      : 'dashboards'

    return axiosCommonReq({
      signal,
    }).get(`/reporting/${dashboardUrl}/visitor_engagement_details.json`, {
      params: {
        ...params.filterParams,
        access_token: params.accessToken,
        password: params.password,
      },
    })
  },
  downloadCSV: (params = {}) => {
    return axiosCommonReq({ transformResConfig: false }).get(
      'reporting/dashboards/visitor_engagement_details.csv',
      {
        params,
        headers: noHeaderData,
      },
    )
  },
}

const { getVisitorCardData, downloadCSV } = visitorEngagementEndpoints,
  cancelApiObject = defineCancelApiObject(visitorEngagementEndpoints)

const visitorEngagementApi = {
  getCardData: (params: any) =>
    apiWrapper({
      endPoint: getVisitorCardData,
      params,
      responseFormat: visitorEngagementFormattedResponses.getCardResponse,
      errorFailureAction: handleStatus500,
    }),
  downloadCSV: (params: any) =>
    apiWrapper({
      endPoint: downloadCSV,
      params,
    }),
}

export default visitorEngagementApi
